import { Controller } from "@hotwired/stimulus"
import { createTurboDataTable, destroyTurboDataTable } from "lib/datatables_turbo"
import { htmlEscape, dataTruncate } from "lib/helpers"

// Example on `app/views/users/edit.haml`:
//   #user_subscriptions.padded-tb{ data: {
//       controller: 'users--subscriptions-table',
//       'users--subscriptions-table-user-id-value': @user.id,
//       'users--subscriptions-table-remove-path-value': admin_subscriptions_remove_path(@current_app),
//       'users--subscriptions-table-subscriptions-root-value': admin_subscriptions_path(@current_app),
//       'users--subscriptions-table-reader-value': current_user_admin_reader?,
//     } }
//     %table#subscriptions_table{ data: { 'users--subscriptions-table-target': 'table' } }
//
export default class extends Controller {
  static targets = ["table"]

  static values = {
    userId: String,
    removePath: String,
    subscriptionsRoot: String,
    reader: { type: Boolean, default: false },
  }

  connect() {
    if (!this.hasTableTarget) return

    this._subscriptionDialog = (path, id) => this.openDialog(path, id)
    this._removeSubscription = (id) => this.removeOne(id)
    this._removeSubscriptions = () => this.removeMany()
    window.subscriptionDialog = this._subscriptionDialog
    window.removeSubscription = this._removeSubscription
    window.removeSubscriptions = this._removeSubscriptions

    this.#initDataTable()
    this.#bindCheckboxChanges()

    $(this.element).find("div.top").html("Devices")
  }

  disconnect() {
    if (this.dataTable) {
      this.dataTable = destroyTurboDataTable(this.dataTable)
    }
    $("#subscriptions_table_wrapper").off(".subsTable")
    $("#check-all").off(".subsTable")

    if (window.subscriptionDialog === this._subscriptionDialog) delete window.subscriptionDialog
    if (window.removeSubscription === this._removeSubscription) delete window.removeSubscription
    if (window.removeSubscriptions === this._removeSubscriptions) delete window.removeSubscriptions
  }

  openDialog(path, id) {
    $("#subscriptions_dialog").load(path + id, function () {
      $("#subscription-modal").modal("show")
      $("#subscription-modal").find(".modal-title").append(" " + id)
    })
  }

  removeOne(id) {
    if (!confirm("Are you sure?")) return false

    const ids = $.makeArray(id)
    $(".dataTables_processing").css("display", "block")

    $.get(this.removePathValue, { item_ids: ids }, () => {
      $("#subscription-modal").modal("hide")
      if (this.dataTable) this.dataTable.ajax.reload()
    })
  }

  removeMany() {
    const groupName = $("input#check-all").val()
    const checkboxes = $(`input[name^='${groupName}']:checked`)
    const available = $(`input[name^='${groupName}']`)

    if (!available.length) return false
    if (!checkboxes.length) {
      alert("Please select at least one item")
      return false
    }
    if (!confirm("Are you sure? All selected items will be removed")) return false

    $(".dataTables_processing").css("display", "block")

    const ids = $.makeArray(checkboxes.map(function () { return $(this).val() }))

    $.get(this.removePathValue, { item_ids: ids }, () => {
      if (this.dataTable) this.dataTable.ajax.reload()
    })
  }

  #initDataTable() {
    const $table = $(this.tableTarget)
    const subscriptionsRoot = this.subscriptionsRootValue

    this.dataTable = createTurboDataTable($table, {
      serverSide: true,
      stateSave: false,
      dom: 'rtp<"toolbar">i',
      pagingType: "full_numbers",
      ajax: {
        url: this.subscriptionsRootValue || "subscriptions",
        data: (d) => {
          d.user_id = this.userIdValue
        },
      },
      stateLoadParams: (settings, data) => {
        data.search.search = ""
      },
      footerCallback: () => {
        $("#check-all").attr("checked", false)
      },
      initComplete: () => {
        if (!this.readerValue) {
          this.#installToolbar()
        }
      },
      columnDefs: [
        {
          targets: 0,
          createdCell(cell, cellData) {
            $(cell).html(
              `<input type="checkbox" class="table-checkbox-row" id="check--users${cellData}" name="item_ids[]" value="${cellData}"/> <label for="check--users${cellData}"><label/>`,
            )
          },
          sortable: false,
        },
        {
          targets: 2,
          createdCell(cell, cellData, rowData) {
            if (rowData[4] === "email") {
              $(cell).html(rowData[7])
            } else {
              const truncated = dataTruncate(htmlEscape(rowData[2]), 40)
              $(cell).html(
                `<a href="#" data-turbo="false" id="device${rowData[1]}" onclick="subscriptionDialog('${subscriptionsRoot}/', ${rowData[1]}); return false;"><span>${truncated}</span></a>`,
              )
            }
          },
        },
        { targets: 3, visible: false },
        {
          targets: 4,
          createdCell(cell, cellData) {
            let title
            switch (cellData) {
              case "apns":
                title = "APNS"
                return $(cell).html(`<img src="${window.apple_logo_url}" alt="${title}" title="${title}"/>&nbsp;${title}`)
              case "apns_voip":
                title = "APNS VOIP"
                return $(cell).html(`<img src="${window.apple_logo_url}" alt="${title}" title="${title}"/>&nbsp;${title}`)
              case "gcm":
                title = "FCM"
                return $(cell).html(`<img src="${window.android_logo_url}" alt="${title}" title="${title}"/>&nbsp;${title}`)
              case "email":
                title = "E-Mail"
                return $(cell).html(`<img src="${window.tick_logo_url}" alt="${title}" title="${title}"/>&nbsp;${title}`)
            }
          },
        },
        { targets: [0, 2], sortable: false },
      ],
    })
  }

  #installToolbar() {
    const $toolbar = $(this.element).find("div.toolbar").not(".rich")
    $toolbar.html('<a href="#" class="remove js-remove-subs">Remove selected</a>')
    $toolbar.find(".js-remove-subs").on("click", (e) => {
      e.preventDefault()
      this.removeMany()
    })
  }

  #bindCheckboxChanges() {
    $("#subscriptions_table_wrapper").on("change.subsTable", ".table-checkbox-row", function () {
      const isChecked = $(this).prop("checked")
      $(this).closest("tr").toggleClass("selected-row", isChecked)

      const selectedCount = $(".table-checkbox-row:checked").length
      const totalCount = $(".table-checkbox-row").length
      $("#check-all").prop("checked", selectedCount > 0 && selectedCount === totalCount)
    })

    $("#check-all").on("change.subsTable", function () {
      const isChecked = $(this).prop("checked")
      $(".table-checkbox-row").prop("checked", isChecked).closest("tr").toggleClass("selected-row", isChecked)
    })
  }

}
